// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2--0s","header":"MessagesList_header__3TtrV","chat":"MessagesList_chat__1MhCb"};